import { LitElement, html, css } from 'lit';

export class ModeSelector extends LitElement {
  static styles = css`
    :host {
      display: block;
    }

    .mode-grid {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 10px;
    }

    .mode-btn {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 20px 12px;
      background: white;
      border: 2px solid transparent;
      border-radius: 16px;
      cursor: pointer;
      transition: all 0.2s ease;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }

    .mode-btn:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
    }

    .mode-btn.active {
      border-color: #667eea;
      background: rgba(102, 126, 234, 0.05);
    }

    .mode-icon {
      width: 40px;
      height: 40px;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 12px;
      transition: background 0.2s ease;
    }

    .mode-btn.active .mode-icon {
      background: rgba(102, 126, 234, 0.15);
    }

    .mode-icon svg {
      width: 24px;
      height: 24px;
      stroke: #667eea;
    }

    .mode-label {
      font-size: 0.875rem;
      font-weight: 600;
      color: #333;
    }

    .mode-btn.active .mode-label {
      color: #667eea;
    }

    @media (max-width: 480px) {
      .mode-grid {
        grid-template-columns: repeat(3, 1fr);
        gap: 6px;
      }

      .mode-btn {
        padding: 16px 8px;
      }

      .mode-icon {
        width: 36px;
        height: 36px;
        margin-bottom: 8px;
      }

      .mode-icon svg {
        width: 20px;
        height: 20px;
      }

      .mode-label {
        font-size: 0.75rem;
      }
    }
  `;

  static properties = {
    activeMode: { type: String }
  };

  constructor() {
    super();
    this.activeMode = 'flashcard';
  }

  _selectMode(mode) {
    this.activeMode = mode;
    this.dispatchEvent(new CustomEvent('mode-change', {
      detail: { mode },
      bubbles: true,
      composed: true
    }));
  }

  render() {
    const modes = [
      {
        id: 'flashcard',
        label: 'Kaarten',
        icon: html`<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="9" y1="9" x2="15" y2="9"></line>
          <line x1="9" y1="15" x2="15" y2="15"></line>
        </svg>`
      },
      {
        id: 'quiz',
        label: 'Quiz',
        icon: html`<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
          <line x1="12" y1="17" x2="12.01" y2="17"></line>
        </svg>`
      },
      {
        id: 'game',
        label: 'Spel',
        icon: html`<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
        </svg>`
      },

      {
        id: 'conjugations',
        label: 'Werkwoorden',
        icon: html`<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
          <line x1="16" y1="13" x2="8" y2="13"></line>
          <line x1="16" y1="17" x2="8" y2="17"></line>
          <polyline points="10 9 9 9 8 9"></polyline>
        </svg>`
      },
      {
        id: 'progress',
        label: 'Voortgang',
        icon: html`<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="20" x2="18" y2="10"></line>
          <line x1="12" y1="20" x2="12" y2="4"></line>
          <line x1="6" y1="20" x2="6" y2="14"></line>
        </svg>`
      }
    ];

    return html`
      <div class="mode-grid">
        ${modes.map(mode => html`
          <button 
            class="mode-btn ${this.activeMode === mode.id ? 'active' : ''}"
            @click="${() => this._selectMode(mode.id)}"
          >
            <div class="mode-icon">${mode.icon}</div>
            <span class="mode-label">${mode.label}</span>
          </button>
        `)}
      </div>
    `;
  }
}

customElements.define('mode-selector', ModeSelector);
